module.exports = __webpack_public_path__ + "static/media/sf-test-9.86ecd343.mp3";